import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/** @jsx $jsx */
import { $jsx } from 'framework7';
import '../css/home.css';
import { url } from '../js/api/endpoint';
import language from '../js/stores/language.js';
import user from '../js/stores/user.js';
import car from '../js/stores/car.js';
import notification from '../js/stores/notification.js';
import place from '../js/stores/place.js';
import carLoanItemLibrary from '../js/controllers/car-loan-item-lib.js';
import RightPanelPage from './home/panel-right.f7.html';
import Pager from '../pages/components/pager.f7.html';
import CarCard from '../pages/car/components/card.f7.html';
import GoogleMapItem from '../pages/components/google-map.f7.html';
import * as dayjs from 'dayjs';
import * as relativeTime from 'dayjs/plugin/relativeTime';
import * as duration from 'dayjs/plugin/duration';
import dayjsLocales from '../js/locale/dayjs.js';
function framework7Component(props, _ref) {
  var $ = _ref.$,
    $f7 = _ref.$f7,
    $on = _ref.$on,
    $update = _ref.$update,
    $onMounted = _ref.$onMounted,
    $f7route = _ref.$f7route,
    $f7router = _ref.$f7router;
  var locale = language.getters.Item.value;
  var langCode = language.getters.Name.value;
  var isLogged = user.getters.isLogged.value;
  var carList = [];
  var notificationList = [];
  var newNotifications = 0;
  var pagerParams = {};
  var defaultRowsPerPage = 2;
  var currentPlacesList = [];
  var selectedPlacesListIds = [];
  var selectLocalities = null;
  var onPopupOpen = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      var element;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            isLogged = user.getters.isLogged.value;
            if (!isLogged) {
              element = document.querySelector('.popup-backdrop');
              if (element) {
                element.remove();
              }
            }
            $update();
            e.preventDefault();
            return _context.abrupt("return");
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onPopupOpen(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var extraSetup = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _t;
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            $f7.preloader.show();
            _context2.prev = 1;
            _context2.next = 2;
            return onCheckExternalParams();
          case 2:
            $f7.preloader.hide();
            _context2.next = 4;
            break;
          case 3:
            _context2.prev = 3;
            _t = _context2["catch"](1);
            console.error(_t);
            $f7.preloader.hide();
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 3]]);
    }));
    return function extraSetup() {
      return _ref3.apply(this, arguments);
    };
  }();
  $onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    return _regeneratorRuntime.wrap(function (_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          selectLocalities = $f7.smartSelect.create({
            el: '#smart-select-localities',
            searchbar: false,
            closeOnSelect: 'false'
          });
          setTimeout(function () {
            extraSetup();
          }, 750);
          onStartPage();
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  })));
  $f7.on('updatePlacesList', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var locations, placesList;
    return _regeneratorRuntime.wrap(function (_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          locations = document.getElementById("search-place-locations-list").value;
          placesList = locations.split(",");
          currentPlacesList = placesList;
          _context4.next = 1;
          return setPlacesList(placesList);
        case 1:
          $('.tempo').text(locations.substring(0, 27) + "...");
          $update();
        case 2:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  })));
  $on('pageBeforeRemove', function () {
    $f7.off('updatePlacesList');
  });
  var changeSelectedPlaces = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(e) {
      return _regeneratorRuntime.wrap(function (_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 1;
            return setPlacesList(selectLocalities.getValue());
          case 1:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function changeSelectedPlaces(_x2) {
      return _ref6.apply(this, arguments);
    };
  }();
  var setPlacesList = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(list) {
      var queryString, result;
      return _regeneratorRuntime.wrap(function (_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            queryString = list.map(function (id, index) {
              return "localitiesList[".concat(index, "]=").concat(id);
            }).join('&');
            _context6.next = 1;
            return place.dispatch('getLocalitiesList', queryString);
          case 1:
            result = _context6.sent;
            if (result.status !== undefined && result.status !== 200) {
              console.log(result.data.messages.error);
              result = [];
            }
            selectedPlacesListIds = result.map(function (item) {
              return Number(item.LocationId);
            });
          case 2:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return function setPlacesList(_x3) {
      return _ref7.apply(this, arguments);
    };
  }();
  var resetSearch = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      return _regeneratorRuntime.wrap(function (_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            currentPlacesList = [];
            selectedPlacesListIds = [];
            $('input[id^="search-place-"]').value('');
            $('.tempo').text(locale.translate('general.select'));
            _context7.next = 1;
            return callPager({
              rows: defaultRowsPerPage
            });
          case 1:
            $update();
          case 2:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function resetSearch() {
      return _ref8.apply(this, arguments);
    };
  }();
  var doSearch = /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
      return _regeneratorRuntime.wrap(function (_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 1;
            return callPager({
              rows: defaultRowsPerPage,
              filter: createLocalitiesForm()
            });
          case 1:
            $update();
          case 2:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    return function doSearch() {
      return _ref9.apply(this, arguments);
    };
  }();
  var createLocalitiesForm = function createLocalitiesForm() {
    var formFilter = new FormData();
    for (var i = 0; i < selectedPlacesListIds.length; i++) {
      formFilter.append("ContactLocalityId[".concat(i, "]"), selectedPlacesListIds[i]);
    }
    return formFilter;
  };
  var onStartPage = /*#__PURE__*/function () {
    var _ref0 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
      return _regeneratorRuntime.wrap(function (_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            if (!isLogged) {
              _context9.next = 2;
              break;
            }
            _context9.next = 1;
            return notification.dispatch('getReceiverList');
          case 1:
            notificationList = _context9.sent;
            if (!(notificationList === undefined || notificationList.length == 0)) {
              newNotifications = notificationList.filter(function (item) {
                return item.NotificationWasRead == "0";
              });
            }
          case 2:
            _context9.next = 3;
            return callPager({
              rows: defaultRowsPerPage
            });
          case 3:
            $update();
          case 4:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }));
    return function onStartPage() {
      return _ref0.apply(this, arguments);
    };
  }();
  var onStart = /*#__PURE__*/function () {
    var _ref1 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee0(e, done) {
      return _regeneratorRuntime.wrap(function (_context0) {
        while (1) switch (_context0.prev = _context0.next) {
          case 0:
            onStartPage();
            done();
          case 1:
          case "end":
            return _context0.stop();
        }
      }, _callee0);
    }));
    return function onStart(_x4, _x5) {
      return _ref1.apply(this, arguments);
    };
  }();
  var callPager = /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee1() {
      var _ref11,
        _ref11$page,
        page,
        _ref11$rows,
        rows,
        _ref11$sidx,
        sidx,
        _ref11$sdir,
        sdir,
        _ref11$filter,
        filter,
        result,
        _args1 = arguments;
      return _regeneratorRuntime.wrap(function (_context1) {
        while (1) switch (_context1.prev = _context1.next) {
          case 0:
            _ref11 = _args1.length > 0 && _args1[0] !== undefined ? _args1[0] : {}, _ref11$page = _ref11.page, page = _ref11$page === void 0 ? 1 : _ref11$page, _ref11$rows = _ref11.rows, rows = _ref11$rows === void 0 ? 4 : _ref11$rows, _ref11$sidx = _ref11.sidx, sidx = _ref11$sidx === void 0 ? 0 : _ref11$sidx, _ref11$sdir = _ref11.sdir, sdir = _ref11$sdir === void 0 ? 0 : _ref11$sdir, _ref11$filter = _ref11.filter, filter = _ref11$filter === void 0 ? "" : _ref11$filter;
            _context1.next = 1;
            return car.dispatch('getCarList', {
              page: page,
              rows: rows,
              sidx: sidx,
              sdir: sdir,
              filter: filter
            });
          case 1:
            result = _context1.sent;
            if (!(result.status !== undefined && result.status !== 200)) {
              _context1.next = 2;
              break;
            }
            $f7.toast.show({
              text: result.data.messages.error
            });
            return _context1.abrupt("return");
          case 2:
            if (!(Number(result.totalRecords) === 0)) {
              _context1.next = 4;
              break;
            }
            $f7.toast.show({
              text: 'No data was found according to that criteria',
              closeTimeout: 5000
            });
            _context1.next = 3;
            return resetSearch();
          case 3:
            return _context1.abrupt("return");
          case 4:
            carList = result.rows;
            pagerParams = {
              "currentPage": result.currentPage,
              "totalRecords": result.totalRecords,
              "totalPages": result.totalPages
            };
            $update();
          case 5:
          case "end":
            return _context1.stop();
        }
      }, _callee1);
    }));
    return function callPager() {
      return _ref10.apply(this, arguments);
    };
  }();
  var goPage = /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee10(value) {
      var params;
      return _regeneratorRuntime.wrap(function (_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            params = value.detail;
            if (selectedPlacesListIds.length > 0) {
              params.filter = createLocalitiesForm();
            }
            _context10.next = 1;
            return callPager(params);
          case 1:
          case "end":
            return _context10.stop();
        }
      }, _callee10);
    }));
    return function goPage(_x6) {
      return _ref12.apply(this, arguments);
    };
  }();
  var refreshPage = /*#__PURE__*/function () {
    var _ref13 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
      return _regeneratorRuntime.wrap(function (_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            _context11.next = 1;
            return language.dispatch('checkLanguage');
          case 1:
            $update();
          case 2:
          case "end":
            return _context11.stop();
        }
      }, _callee11);
    }));
    return function refreshPage() {
      return _ref13.apply(this, arguments);
    };
  }();
  var humanizeDate = function humanizeDate(paramDate) {
    return dayjs(paramDate).fromNow();
  };
  var goLoan = /*#__PURE__*/function () {
    var _ref14 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee12(e) {
      var anchor, notificationId, notificationWasRead, referenceId, data, obj, _t2;
      return _regeneratorRuntime.wrap(function (_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            $f7.preloader.show();
            _context12.prev = 1;
            anchor = e.target.closest("a");
            notificationId = anchor.dataset.notificationId;
            notificationWasRead = parseInt(anchor.dataset.notificationWasRead);
            referenceId = anchor.dataset.notificationReferenceId;
            data = {
              NotificationId: notificationId
            };
            if (!(notificationWasRead != 1)) {
              _context12.next = 3;
              break;
            }
            _context12.next = 2;
            return notification.dispatch('setAsRead', data);
          case 2:
            document.getElementById("notification-item-".concat(notificationId)).classList.remove('notification-not-read');
            newNotifications = newNotifications.filter(function (item) {
              return item.NotificationId == notificationId;
            });
          case 3:
            _context12.next = 4;
            return carLoanItemLibrary.getLoanData(referenceId);
          case 4:
            obj = _context12.sent;
            $('.popup-close').trigger('click');
            $f7.views.main.router.navigate("/loan-item/".concat(referenceId), obj);
            $f7.preloader.hide();
            _context12.next = 6;
            break;
          case 5:
            _context12.prev = 5;
            _t2 = _context12["catch"](1);
            console.error(_t2);
            $f7.preloader.hide();
          case 6:
            $update();
          case 7:
          case "end":
            return _context12.stop();
        }
      }, _callee12, null, [[1, 5]]);
    }));
    return function goLoan(_x7) {
      return _ref14.apply(this, arguments);
    };
  }();
  var onCheckExternalParams = /*#__PURE__*/function () {
    var _ref15 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
      var params, route, loanId, hasOwnership, obj, _route, carId, carItem;
      return _regeneratorRuntime.wrap(function (_context13) {
        while (1) switch (_context13.prev = _context13.next) {
          case 0:
            params = new URLSearchParams(window.location.search);
            window.history.replaceState({
              path: "/"
            }, 'De LeenAuto', "/");
            if (!(params.get('r') != null && params.get('l') != null)) {
              _context13.next = 5;
              break;
            }
            if (isLogged) {
              _context13.next = 1;
              break;
            }
            return _context13.abrupt("return");
          case 1:
            route = params.get('r');
            loanId = params.get('l');
            _context13.next = 2;
            return carLoanItemLibrary.hasOwnership(loanId);
          case 2:
            hasOwnership = _context13.sent;
            if (!(hasOwnership.value < 1)) {
              _context13.next = 3;
              break;
            }
            console.log(hasOwnership.logMessage);
            return _context13.abrupt("return");
          case 3:
            _context13.next = 4;
            return carLoanItemLibrary.getLoanData(loanId);
          case 4:
            obj = _context13.sent;
            $f7.views.main.router.navigate("/".concat(route, "/").concat(loanId), obj);
          case 5:
            if (!(params.get('r') != null && params.get('c') != null)) {
              _context13.next = 7;
              break;
            }
            _route = params.get('r');
            carId = params.get('c');
            _context13.next = 6;
            return carLoanItemLibrary.loadCarItem(carId);
          case 6:
            carItem = _context13.sent;
            $f7.views.main.router.navigate("/".concat(_route, "/"), carItem);
          case 7:
          case "end":
            return _context13.stop();
        }
      }, _callee13);
    }));
    return function onCheckExternalParams() {
      return _ref15.apply(this, arguments);
    };
  }();
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="home">
  <!-- Top Navbar -->
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner">
      <div class="left">
        <a class="link icon-only" href="/panel-left/">
          <i class="icon material-icons">home</i>
        </a>
      </div>
      <div class="title sliding">
        De LeenAuto
      </div>
      <div class="right">
        <a class="link" href="/car-dashboard/">
          <i class="icon material-icons color-teal">car_rental</i>
          <span class="hidden-xs-down">${locale.translate('home.topMenu.offer')}</span>
        </a>
        <a class="link" href="/landing-offer/">
          <i class="icon material-symbols-outlined color-orange">swap_driving_apps</i>
          <span class="hidden-xs-down">${locale.translate('home.topMenu.lend')}</span>
        </a>
        <a class="link" href="/landing-lend/">
          <i class="icon material-symbols-outlined color-blue">person_raised_hand</i>
          <span class="hidden-xs-down">${locale.translate('home.topMenu.howItWorks')}</span>
        </a>
        <a class="link" href="/landing-contact/">
          <i class="icon material-symbols-outlined color-red">contact_mail</i>
          <span class="hidden-xs-down">${locale.translate('home.topMenu.contact')}</span>
        </a>
        ${isLogged && $h`
        <a class="link icon-only popup-open" data-popup=".notification-popup" @click=${onPopupOpen}>
          <i class="icon material-icons color-teal">notifications
            ${newNotifications.length > 0 && $h`
            <span class="badge color-red">${newNotifications.length}</span>
            `}
          </i>
        </a>
        `}
        <a class="link icon-only panel-open" data-panel=".panel-right" href="#">
          <i class="icon material-icons">more_vert</i>
        </a>
      </div>
      <div class="title-large">
        <div class="title-large-text">De LeenAuto</div>
      </div>
    </div>
  </div>
  <!-- Scrollable page content-->
  <div class="page-content ptr-content" @ptr:refresh=${onStart}>
    <div class="ptr-preloader">
      <div class="preloader"></div>
      <div class="ptr-arrow"></div>
    </div>
    <div class="prev">
      <div class="left-side sub-item hidden-xs-down">
      </div>
      <div class="center-side sub-item">
        <div class="block block-strong">
          <div class="text-align-center">
            <img src="./static/logo.png" height="67" width="267"/>
          </div>
          <div class="text-align-center">
            <p>
              <h1>${locale.translate('home.main.borrowCarLabel')}</h1>
              ${locale.translate('home.main.sloganLabel')}
            </p>  
          </div>
        </div>
        <div class="block stack-content text-align-center">
          <div class="card sub-item">
            <div class="sub-header text-align-center">${locale.translate('home.main.flexible')}</div>
            <div class="card-content card-content-padding">
              <div class="item-media">
                <i class="icon"><img src="./static/flexibel.png" width="44"/></i>
              </div>
            </div>
          </div>
          <div class="card sub-item">
            <div class="sub-header text-align-center">${locale.translate('home.main.durable')}</div>
            <div class="card-content card-content-padding">
              <div class="item-media">
                <i class="icon"><img src="./static/duurzaam.png" width="44"/></i>
              </div>
            </div>
          </div>
          <div class="card sub-item">
            <div class="sub-header text-align-center">${locale.translate('home.main.transparent')}</div>
            <div class="card-content card-content-padding">
              <div class="item-media">
                <i class="icon"><img src="./static/transparant.png" width="44"/></i>
              </div>
            </div>
          </div>
        </div>
        <div class="list">
          <ul>
            <li class="item-content item-input">
              <div class="item-inner">
                <div class="item-title item-label">${locale.translate('home.main.enterLocationToSearch')}</div>
                <div class="item-input-wrap">
                  <input id="search-place-address" name="CarAppointmentAddress" type="text" autocomplete="off" placeholder="${locale.translate('general.place')}" value="" />
                  <input id="search-place-coords-latitude" name="CarAppointmentLatitude" type="hidden" value=""/>
                  <input id="search-place-coords-longitude" name="CarAppointmentLongitude" type="hidden" value=""/>
                  <input id="search-place-locations-list" name="CarLocationsList" type="hidden" value=""/>
                </div>
              </div>
              <div class="item-after">
                <a href="#" class="button button-fill button-raised popup-open location-button" data-popup=".search-popup">
                  <i class="icon material-symbols-outlined">location_on</i>
                </a>
              </div>
            </li>
          </ul>
        </div>
        <div id="search-area"> <!--Search area-->
          <div class="block block-strong-ios block-outline-ios" >
            <div class="list">
              <ul>
                <li>
                  <a id="smart-select-localities" href="#" class="item-link smart-select" data-searchbar="false">
                    <select id="contact-localities" name="ContactLocalityId" multiple @change="${changeSelectedPlaces}"> 
                    ${currentPlacesList.length > 0 && $h`
                    ${currentPlacesList.map((item) => $h`
                      <option value="${item}" selected>${item}</option> 
                    `)}
                    `}
                    </select>
                    <div class="item-content">
                      <div class="item-inner">
                        <div class="item-title">${locale.translate('user.edit.location.locality')}</div>
                        <div class="item-after tempo">${locale.translate('general.select')}</div>
                      </div>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="block block-strong">
            <p class="grid grid-cols-3 xlarge-grid-cols-3">
              <div>
                <a href="#" class="button button-small button-fill button-raised color-green" @click="${resetSearch}">
                  <span class="material-symbols-outlined">mop</span>${locale.translate('general.clear')}
                </a>
              </div>
              <div></div>
              <div>
                <a href="#" class="button button-small button-fill button-raised color-green" @click="${doSearch}">
                  <span class="material-symbols-outlined">search</span>${locale.translate('googleMap.dialog.title')}
                </a>
              </div>
            </p>
          </div>
        </div>
        <div class="block-title">${locale.translate('home.main.loanOfferLabel')}</div>
        <div class="block">
          <${CarCard} list=${carList}/>
          <${Pager} params=${pagerParams} @myEvent=${goPage} rows-per-page=${defaultRowsPerPage}/>
        </div>
        <div class="block block-outline inset list">
          <ul>
            <li>
              <a href="/about/" class="item-content item-link">
                <div class="item-inner">
                  <div class="item-title"><i class="icon f7-icons color-lime">info_circle</i> About ...</div>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="right-side sub-item hidden-xs-down">
      </div>
    </div>
  </div>
  <!-- Right panel with reveal effect-->
  <${RightPanelPage} @reloadLanguage=${refreshPage} />
  ${isLogged && $h`
  <!-- Popup modal for notifications -->
  <div class="popup notification-popup">
    <div class="page">
      <div class="navbar">
        <div class="navbar-bg"></div>
        <div class="navbar-inner">
          <div class="title">${locale.translate('home.topMenu.notifications')}</div>
          <div class="right"><a class="link popup-close"><i class="icon material-symbols-outlined color-red">cancel</i></a></div>
        </div>
      </div>
      <div class="page-content">
        <div class="block">
          <div class="list list-dividers inset list-outline list-strong media-list">
            <ul>
            ${notificationList.length > 0 && $h`
            ${notificationList.map((item) => $h`
              <li>
                <a id="notification-item-${item.NotificationId}" class="item-link item-content ${item.NotificationWasRead == 0 && $h`notification-not-read`}"
                @click="${goLoan}" data-notification-id="${item.NotificationId}" data-notification-reference-id="${item.NotificationReferenceId}" 
                data-notification-was-read="${item.NotificationWasRead}" title="${item.NotificationBodyMessage}">
                  <div class="item-media"><img style="border-radius: 8px" src="${url}/${item.FilePath}/${item.FileName}" width="40" />
                  </div>
                  <div class="item-inner">
                    <div class="item-title-row">
                      <div class="item-title">${item.NotificationTitleMessage}</div>
                      <div class="item-after">${humanizeDate(item.NotificationDate)}</div>
                    </div>
                    <div class="item-text" data-notification-id="${item.NotificationId}">${item.NotificationBodyMessage}</div>
                  </div>
                </a>
              </li>
            `)}
            `}
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  `}
  <!-- Popup modal for google maps locations -->
  <${GoogleMapItem} selector="search" use-locations="1"/>
</div>
`
    }
    ;
}
framework7Component.id = '74157ebfa4';
framework7Component.style = "\n.tempo {\n  width: 200px; /* Set a fixed width for the div */\n  white-space: nowrap !important; /* Prevents text from wrapping to the next line */\n  overflow: hidden !important; /* Hides overflow text */\n  text-overflow: ellipsis !important; /* Adds ellipsis (...) for overflow text */\n  display: block !important; /* Ensures the div behaves like a block element */\n  max-width: 100%; /* Ensures it doesn't exceed the parent width */\n}\n";
export default framework7Component;